<template>
  <div id="brandPopularModelsHorizontalScrollComponent" class="scroll-parent-element-component horizontal-scroll-component">
    <div id="brandPopularModelsHorizontalScroll" class="scroll-parent-element scroll-parent" data-has-scrollbar="true" data-scroll-region="min">
      <div class="scroll-horizontal">
        <div class="bpm-card sokal-flex sokal-flex-col sokal-justify-between" data-model="Mustang">
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">
            <div class="bpm-top" style="background-color: #8c2c2d;">
              <h5 class="year-brand sokal-mb-0">2025 Ford</h5>
              <h3 class="model sokal-m-0">Mustang</h3>
              <div class="bg-img sokal-my-1" :style="{ backgroundImage: `url(${images.sedans[0].angleView})` }"></div>
              <div class="start-price sokal-my-2 sokal-mb-0">Starting at $31,920</div>
              <div class="vehicle-count sokal-my-2 sokal-mt-0">12 available</div>
            </div>
            <div class="bpm-bottom">
              <a href="#" class="view-btn">View Inventory</a>
            </div>
          </div>
        </div>
        <div class="bpm-card sokal-flex sokal-flex-col sokal-justify-between" data-model="Bronco">
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">
            <div class="bpm-top" style="background-color: #407246;">
              <h5 class="year-brand sokal-mb-0">2025 Ford</h5>
              <h3 class="model sokal-m-0">Bronco</h3>
              <div class="bg-img sokal-my-1" :style="{ backgroundImage: `url(${images.suvs[0].angleView})` }"></div>
              <div class="start-price sokal-my-2 sokal-mb-0">Starting at $39,995</div>
              <div class="vehicle-count sokal-my-2 sokal-mt-0">23 available</div>
            </div>
            <div class="bpm-bottom">
              <a href="#" class="view-btn">View Inventory</a>
            </div>
          </div>
        </div>
        <div class="bpm-card sokal-flex sokal-flex-col sokal-justify-between" data-model="Explorer">
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">
            <div class="bpm-top" style="background-color: #698ca1;">
              <h5 class="year-brand sokal-mb-0">2025 Ford</h5>
              <h3 class="model sokal-m-0">Explorer</h3>
              <div class="bg-img sokal-my-1" :style="{ backgroundImage: `url(${images.suvs[3].angleView})` }"></div>
              <div class="start-price sokal-my-2 sokal-mb-0">Starting at $41,745</div>
              <div class="vehicle-count sokal-my-2 sokal-mt-0">46 available</div>
            </div>
            <div class="bpm-bottom">
              <a href="#" class="view-btn">View Inventory</a>
            </div>
          </div>
        </div>
        <div class="bpm-card sokal-flex sokal-flex-col sokal-justify-between" data-model="F-150">
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">
            <div class="bpm-top" style="background-color: #052349;">
              <h5 class="year-brand sokal-mb-0">2025 Ford</h5>
              <h3 class="model sokal-m-0">F-150</h3>
              <div class="bg-img sokal-my-1" :style="{ backgroundImage: `url(${images.trucks[0].angleView})` }"></div>
              <div class="start-price sokal-my-2 sokal-mb-0">Starting at $38,810</div>
              <div class="vehicle-count sokal-my-2 sokal-mt-0">78 available</div>
            </div>
            <div class="bpm-bottom">
              <a href="#" class="view-btn">View Inventory</a>
            </div>
          </div>
        </div>
        <div class="bpm-card sokal-flex sokal-flex-col sokal-justify-between" data-model="Ranger">
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">
            <div class="bpm-top" style="background-color: #3e434d;">
              <h5 class="year-brand sokal-mb-0">2025 Ford</h5>
              <h3 class="model sokal-m-0">Ranger</h3>
              <div class="bg-img sokal-my-1" :style="{ backgroundImage: `url(${images.trucks[1].angleView})` }"></div>
              <div class="start-price sokal-my-2 sokal-mb-0">Starting at $33,350</div>
              <div class="vehicle-count sokal-my-2 sokal-mt-0">37 available</div>
            </div>
            <div class="bpm-bottom">
              <a href="#" class="view-btn">View Inventory</a>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-overlay scroll-overlay--left"></div>
      <div class="scroll-overlay scroll-overlay--right"></div>
      <div class="scroll-nav scroll-nav--left">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#brandPopularModelsHorizontalScroll" data-direction="left" tabindex="0"></button>
        </div>
      <div class="scroll-nav scroll-nav--right">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#brandPopularModelsHorizontalScroll" data-direction="right" tabindex="0"></button>
        </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  export default {
    props: ['images'],

    mounted() {
      (function($){
        const scrollElements = {
          init: function() {

            scrollElements.scrollNavInit();

            $('#brandPopularModelsHorizontalScrollComponent .scroll-parent').each(function(){
              
              let parent = '#' + $(this).attr('id');
              let element = parent + ' .scroll-horizontal';
              
              scrollElements.setDataRegion(parent, element);
              scrollElements.setDataHasScrollbar(parent, element);

              $(window).resize(function(){
                scrollElements.setDataHasScrollbar(parent, element);
              })
              
              $(element).on('scroll', function(){
                scrollElements.setDataRegion(parent, element);
              })

            })

            $('#brandPopularModelsHorizontalScrollComponent [data-toggle="tab"]').click(function(){
              setTimeout(function(){
                $('#brandPopularModelsHorizontalScrollComponent .tab-content .scroll-parent').each(function(){
                  let parent = '#' + $(this).attr('id');
                  let element = parent + ' .scroll-horizontal';
                  scrollElements.setDataHasScrollbar(parent, element);
                });
              }, 220);
            });

          }, 

          scrollNavInit: function() {
            
            $('#brandPopularModelsHorizontalScrollComponent .scroll-parent .scroll-nav').click(function(){

              $(this).find('.scroll-nav-btn').focus();
              
              let scrollParent = $(this).find('.scroll-nav-btn').attr('data-scroll-parent');
              let scrollTarget = scrollParent + ' .scroll-horizontal';
              let scrollContent = scrollTarget + ' > *';
              let distance = 0;

              $(scrollContent).each(function(){
                if ($(this).outerWidth() > distance) {
                  distance = $(this).outerWidth();
                }
              })
              
              let currentPosition = scrollElements.getPosition(scrollTarget);

              if ($(this).find('.scroll-nav-btn').attr('data-direction') === 'right') {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition + distance);
              } else {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition - distance);
              }
              
            })
          },

          setDuration: function(distance) {
            return Math.floor(distance / 0.7);
          }, 

          animateScroll: function(parent, element, distance, newPosition) {
            
            $(element).animate({
                scrollLeft: newPosition
            }, scrollElements.setDuration(distance));

            setTimeout(function(){
              scrollElements.setDataRegion(parent, element);
            }, scrollElements.setDuration(distance));
            
          }, 

          getPosition: function(element) {
            return $(element).scrollLeft();
          }, 

          getMaxScroll: function(element) {
            return document.querySelector(element).scrollWidth - (document.querySelector(element).clientWidth + 10);
          }, 

          setDataRegion: function(parent, element) {
            let maxScroll = scrollElements.getMaxScroll(element);
            let currentPosition = scrollElements.getPosition(element);

            if (currentPosition === 0 && maxScroll < 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else if (currentPosition >= maxScroll) {
              $(parent).attr('data-scroll-region', 'max');
            } else if (currentPosition === 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else {
              $(parent).attr('data-scroll-region', 'middle');
            }
          }, 

          setDataHasScrollbar: function(parent, element) {
            if (scrollElements.getPosition(element) === 0 && scrollElements.getMaxScroll(element) <= 0) {
              $(parent).attr('data-has-scrollbar', 'false');
            } else {
              $(parent).attr('data-has-scrollbar', 'true');
            }
          }
        }

        $(document).ready(scrollElements.init);

      })(jQuery)
    }

  }
</script>

<style scoped>
  #brandPopularModelsHorizontalScroll .bpm-card {
    padding: 10px;
    border: 2px solid #E5E5E5;
    border-radius: 20px;
    margin-right: 20px;
  }

  #brandPopularModelsHorizontalScroll .bpm-top {
    padding: 15px;
    color: #ffffff;
    border-radius: 20px;
    text-align: left;
    min-width: 22.5rem;
    min-height: 30rem;
  }

  #brandPopularModelsHorizontalScroll .bg-img {
    background-size: 105%;
    background-position: center;
    background-repeat: no-repeat;
    height: 225px;
  }

  #brandPopularModelsHorizontalScroll .start-price {
    font-size: 1.25rem;
    font-weight: 500;
  }

  #brandPopularModelsHorizontalScroll .vehicle-count {
    opacity: 0.7;
  }

  #brandPopularModelsHorizontalScroll .view-btn {
    background-color: #00142E;
    color: #ffffff;
    border-radius: 50px;
    padding: 12px;
    width: 100%;
    display: block;
    text-align: center;
    text-decoration: none;
    border: 2px solid #00142E;
  }
  #brandPopularModelsHorizontalScroll .view-btn:hover,
  #brandPopularModelsHorizontalScroll .view-btn:focus,
  #brandPopularModelsHorizontalScroll .view-btn:active {
    opacity: 0.9;
  }
</style>

<style scoped>
  .horizontal-scroll-component {
    --scroll-overlay-gradient-rgba-min: rgba(255, 255, 255, 0);
    --scroll-overlay-gradient-rgba-max: rgba(255, 255, 255, 1);
    --overlay-color-min: var(--scroll-overlay-gradient-rgba-min, rgba(255, 255, 255, 0));
    --overlay-color-max: var(--scroll-overlay-gradient-rgba-max, rgba(255, 255, 255, 1))
  }

  .horizontal-scroll-component {
      overflow: hidden
  }

  .horizontal-scroll-component .scroll-parent {
      position: relative
  }

  .horizontal-scroll-component .scroll-horizontal {
      position: relative;
      background-color: #ffffff;
      overflow-x: scroll;
      width: 100%;
      margin: 0 auto;
      padding: 15px;
      white-space: nowrap;
      -ms-overflow-style: none;
      scrollbar-width: none
  }

  .horizontal-scroll-component .scroll-horizontal::-webkit-scrollbar {
      display: none
  }

  .horizontal-scroll-component .scroll-horizontal>* {
      display: inline-block;
      white-space: normal;
      vertical-align: middle
  }

  .horizontal-scroll-component .scroll-overlay,.horizontal-scroll-component .scroll-nav {
      width: 15%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 1;
      -webkit-transition: all 0.1s ease;
      -moz-transition: all 0.1s ease;
      -o-transition: all 0.1s ease;
      transition: all 0.1s ease
  }

  .horizontal-scroll-component .scroll-overlay--left {
      left: -1%;
      background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to left, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-overlay--right {
      right: -1%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to right, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-nav {
      display: flex;
      flex-direction: column;
      justify-content: center
  }

  .horizontal-scroll-component .scroll-nav--right {
      right: 0;
      align-items: flex-end;
      padding-right: 1%
  }

  .horizontal-scroll-component .scroll-nav--left {
      left: 0;
      align-items: flex-start;
      padding-left: 1%
  }

  .horizontal-scroll-component .scroll-nav-btn {
      font-size: inherit;
      font-weight: 300;
      width: 30px;
      height: 30px;
      color: #ffffff;
      background-color: transparent;
      border: solid 2px transparent;
      border-radius: 100%;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      transition: all 0.3s ease;
      background-image: url("https://d2v1gjawtegg5z.cloudfront.net/assets/arrow-right-black-43b6b23ed61b72a8b073b2dfca374fb5ced57d6df7373641f7198deedda943b7.png");
      background-size: 35%;
      background-position: center;
      background-repeat: no-repeat
  }

  .horizontal-scroll-component[data-light-theme="true"] .scroll-nav-btn {
      -webkit-filter: invert(1);
      filter: invert(1)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn {
      transform: rotateY(180deg)
  }

  .horizontal-scroll-component .scroll-nav-btn:hover {
      opacity: 0.7
  }

  .horizontal-scroll-component .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav-btn:active {
      color: #ffffff;
      -webkit-transform: scale(1.5);
      transform: scale(1.5)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active {
      -webkit-transform: rotateY(180deg) scale(1.5);
      transform: rotateY(180deg) scale(1.5)
  }

  .horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,.horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-overlay,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
      opacity: 0;
      visibility: hidden
  }

  .horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-horizontal {
      text-align: center
  }

  @media (max-width: 767px) {
      .horizontal-scroll-component .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav-btn:focus {
          opacity:1;
          color: #ffffff;
          -webkit-transform: scale(1.3);
          transform: scale(1.3)
      }

      .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus {
          -webkit-transform: rotateY(180deg) scale(1.3);
          transform: rotateY(180deg) scale(1.3)
      }
  }
</style>